export default __webpack_public_path__ + "static/media/Jenny Rae Le Roux.d7ef1b23.jpg";